import { render, staticRenderFns } from "./bankArchiveGetTotal.vue?vue&type=template&id=23684f3c"
import script from "./bankArchiveGetTotal.vue?vue&type=script&lang=js"
export * from "./bankArchiveGetTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports